/* eslint-disable */
// Don't check the return type here. This allows `ReturnType<T>` to work


import { ORDER_STATUS_DELIVERING } from '../../Constants/Order/Order.constants';
import { orderStatusColors } from '../../Services/Order/Order.service.styles';

const inTransitColor = orderStatusColors[ORDER_STATUS_DELIVERING];

/**
 * Create styles for `<OrderConcreteDeliveries />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<OrderConcreteDeliveries />` styles
 */
const orderConcreteDeliveriesStyles = ({ theme }) => ({
  detailsContainer: {
    [`-webkit-overflow-scrolling`]: `touch`,
    height: `100%`,
    overflowX: `hidden`,
    overflowY: `auto`,
    padding: theme.spacing(1),
    width: `100%`,
  },
  errorIcon: {
    color: `red`,
    marginRight: theme.spacing(1),
  },
  errorMessageContainer: {
    padding: theme.spacing(1),
  },
  growFull: {
    flex: `1 1 auto`,
  },
  loader: {
    height: 2,
  },
  rootContainer: {
    overflowY: `auto`,
    padding: theme.spacing(1) * 2,
  },
  section: {
    [theme.breakpoints.down(`xs`)]: {
      marginBottom: 0,
      padding: theme.spacing(1),
    },
    marginBottom: theme.spacing(1) * 3,
    padding: theme.spacing(1) * 2,
  },
  sectionHeader: {
    backgroundColor: inTransitColor.color[inTransitColor.index],
  },
  summaryContainer: {
    marginBottom: theme.spacing(1) * 3,
  },
  summaryItem: {
    marginBottom: theme.spacing(1) / 2,
  },
});

export default orderConcreteDeliveriesStyles;
